import { makeAutoObservable } from 'mobx';
import { apiServiceDepartments } from '../../services/apiService';
import { CategoryKey, CategoryType } from './copia.type';
import { category, copiaCategories, iconsList } from './copiaConstants';
import { formatDate } from '../../helpers/utils';
import { cacheService } from '../../services/cacheService';
import filterStore from '../../components/CustomFilter/filter.store';

class NewCopiaStore {
  filters: any[] = [];

  categories: CategoryType[] = copiaCategories;

  cards: any[] = [];

  currentCategory: CategoryType = {};

  listModeActive: boolean;

  calendarActive = false;

  showReservePopup = false;

  startDate: Date | string;

  endDate: Date | string;

  searchValue = '';

  queries: any = {};

  autocompleteData: any[] = [];

  showFilters = false;

  currentMenu: number;

  showMap = false;

  showOrtakPopup = false;

  categoryMap: { [key: string]: Function } = {
    apartments: apiServiceDepartments.getApartments,
    hotels: apiServiceDepartments.getHotels,
    restaurants: apiServiceDepartments.getRestaurants,
    constructors: apiServiceDepartments.getEstates,
  };

  fullScreenMap: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  get myReserved() {
    const res = this.cards[this.currentMenu as number].reserved.filter(
      (table: any) => table.userId === cacheService.getMyId,
    );
    return res;
  }

  get isReserved() {
    return !!this.myReserved?.length;
    // return !!this.myReserved.filter((el: any) => +new Date(el.endReservedDate) > +new Date())?.length;
  }

  setShowOrtakPopup = (bool: boolean) => {
    this.showOrtakPopup = bool;
  };

  setFullScreenMap = (bool: boolean) => {
    this.fullScreenMap = bool;
  };

  setShowFilters = (state: boolean) => {
    this.showFilters = state;
  };

  setCurrentMenu = (id: number) => {
    this.currentMenu = id;
  };

  setFilters = (filters: any) => {
    this.filters = filters;
  };

  setShowMap = (bool: boolean) => {
    this.showMap = bool;
  };

  setCards = (cards: any) => {
    this.cards = cards;
  };

  setListModeActive = (bool?: boolean) => {
    this.listModeActive = bool !== undefined ? bool : !this.listModeActive;
  };

  setQueries = async (queries: any) => {
    const query = Object.keys(queries) ? queries : {};
    if (this.listModeActive) query.listModeActive = Number(this.listModeActive);
    this.queries = {
      ...query,
    };
  };

  setCurrentCategory = (category: any) => {
    this.currentCategory = category;
  };

  setCalendarActive = (bool: boolean = !this.calendarActive) => {
    this.calendarActive = bool;
  };

  setStartDate = (date: Date | string) => {
    if (typeof date === 'string') {
      this.startDate = '';
      delete this.queries.startDate;
    } else {
      this.startDate = date;
      this.setQueries({
        ...this.queries,
        startDate: formatDate(date),
      });
    }
  };

  setEndDate = (date: Date | string) => {
    if (typeof date === 'string') {
      this.endDate = '';
      delete this.queries.endDate;
    } else {
      this.endDate = date;
      this.setQueries({
        ...this.queries,
        endDate: formatDate(date),
      });
    }
  };

  setSearchValue = (str: string) => {
    this.searchValue = str;
    this.setQueries({
      ...this.queries,
      search: str,
    });
  };

  getAutocompleteData = async (str?: string, categoryName?: CategoryKey) => {
    const resolve = await apiServiceDepartments.getAutocompleteSearchData({
      type: category[categoryName as CategoryKey],
      query: str || this.searchValue,
    });
    if (!resolve.error) {
      const res = resolve.data.items || resolve.data.result;
      const keys = Object.keys(res);
      const result: any[] = [];
      keys.forEach((key) => {
        res[key].forEach((data: any) => {
          result.push({
            ...data,
            icon: iconsList[key],
          });
        });
      });
      this.setAutocompleteData(result);
    }
  };

  setAutocompleteData = (data: any[]) => {
    this.autocompleteData = data;
  };

  clearFilters = () => {
    this.filters = [];
  };

  clearData = () => {
    this.setCards([]);
    filterStore.setIsLoading(true);
  };
}

export const newCopiaStore = new NewCopiaStore();
